<div class="container-fluid p-0 m-0 w-100 min-vh-100">
    <nav class="navbar navbar-expand-lg gradient-background">
        <div class="container-fluid">
            <a class="navbar-brand link-light text-decoration-none logo-hover ms-1" (ctrl-click)="showVersion()">
                <span class="fs-4 fw-bold">Crono Configurator</span>
            </a>
        </div>
    </nav>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="mt-4 error-template text-center">
                        <h1>Oops! Der opstod en fejl - det beklager vi!</h1>

                        @if (error(); as err) {
                            <div class="error-info mx-auto mt-3 text-start" style="max-width: 720px;">
                                <p class="lead text-center">{{ err.title }}</p>
                                <p class="text-center">{{ err.message }}</p>

                                @if (err.database; as db) {
                                    <div class="alert alert-warning">
                                        <h5 class="alert-heading">
                                            <i class="fa-solid fa-database me-2"></i>Databaseforbindelse fejlede
                                        </h5>
                                        <dl class="row mb-0 small">
                                            @if (db.database) {
                                                <dt class="col-sm-4">Database</dt>
                                                <dd class="col-sm-8"><code>{{ db.database }}</code></dd>
                                            }
                                            @if (db.server) {
                                                <dt class="col-sm-4">Server</dt>
                                                <dd class="col-sm-8"><code>{{ db.server }}</code></dd>
                                            }
                                            @if (db.context) {
                                                <dt class="col-sm-4">Kontekst</dt>
                                                <dd class="col-sm-8"><code>{{ db.context }}</code></dd>
                                            }
                                            @if (db.errorNumber !== null) {
                                                <dt class="col-sm-4">SQL-fejlnr.</dt>
                                                <dd class="col-sm-8"><code>{{ db.errorNumber }}</code></dd>
                                            }
                                        </dl>
                                    </div>
                                }

                                @if (err.correlationId) {
                                    <p class="text-muted small mb-2">
                                        Reference: <code>{{ err.correlationId }}</code>
                                    </p>
                                }

                                @if (technical(); as tech) {
                                    <button type="button" class="btn btn-link btn-sm px-0"
                                        (click)="showDetails.set(!showDetails())">
                                        {{ showDetails() ? 'Skjul tekniske detaljer' : 'Vis tekniske detaljer' }}
                                    </button>
                                    @if (showDetails()) {
                                        <pre class="bg-light border rounded p-2 small mb-0"
                                            style="max-height: 28rem; overflow: auto;">{{ tech }}</pre>
                                    }
                                }
                            </div>
                        }

                        <div class="error-details">
                            <br />
                            @if (flippic)
                            {
                                <img [src]="somethingwentwrong" (click)="flippic = ! flippic"/>
                            }
                            @else
                            {
                                <img [src]="failedJpg" (click)="getRandomePic()"/>
                            }
                            <!-- <div ><i class="fa-solid fa-screwdriver-wrench"></i></div> -->
                        </div>
                        <div class="error-actions">
                            <a href="/" class="mt-4 btn btn-primary btn-lg"><span
                                    class="glyphicon glyphicon-home"></span>
                                Til forsiden. </a>
                        </div>
                        <br />
                        <button class="btn btn-primary" (click)="logout()" >Log ud </button>                            
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>